import { ONGLET_EMPLOYEUR, ONGLET_FORMATION } from "../shared"

export const OngletsAF = [ONGLET_EMPLOYEUR, 'Salaries', ONGLET_FORMATION] as const
export type OngletAF = (typeof OngletsAF)[number]

export const OngletsAFLibellés: Record<OngletAF, string> = {
  Employeur: 'Employeur',
  Salaries: 'Salariés',
  Formation: 'Formation'
}
